import { render, staticRenderFns } from "./mergePartner.vue?vue&type=template&id=5d4f37e5&"
import script from "./mergePartner.vue?vue&type=script&lang=js&"
export * from "./mergePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d4f37e5')) {
      api.createRecord('5d4f37e5', component.options)
    } else {
      api.reload('5d4f37e5', component.options)
    }
    module.hot.accept("./mergePartner.vue?vue&type=template&id=5d4f37e5&", function () {
      api.rerender('5d4f37e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/mergePartner.vue"
export default component.exports